import api from './api';

const resource = 'BlockedNumbers/';

export const list = async (query = '') => {
  return await api.get(resource + 'List' + query);
};

export const create = async (body) => {
  return await api.post(resource + 'Create', body);
};

export const deleteById = async (id) => {
  return await api.delete(resource + 'Delete?id=' + id);
};

const blockedNumberApi = { list, create, deleteById };

export default blockedNumberApi;
